module.exports = __webpack_public_path__ + "static/media/FourM.ed646bd4.png";